var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoGroupHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 104,
    viewBox: "0 0 43 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1547 1H11C5.47715 1 1 5.47715 1 11L1 67.919L1 75.4901V83C1 94.0457 9.9543 103 21 103H43",
    stroke: "#12246c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoGroupHighlight);
export default __webpack_public_path__ + "static/media/two-group-highlight.24c47ecc8fbaac373a21044d5c2f8c53.svg";
export { ForwardRef as ReactComponent };